import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Author } from '../../models/author.model';
import { BlogPost } from '../../models/blog-posts.model';

enum ROUTES {
    ARTICLE = '/posts/',
    AUTHOR = '/author/',
    ERROR = '/error/',
}

@Injectable({
    providedIn: 'root',
})
export class RouterService {
    private articleChangedSubject = new Subject<BlogPost>();
    private authorChangedSubject = new Subject<Author>();
    private curArticle: BlogPost | null = null;
    private curAuthor: Author | null = null;

    public constructor(private router: Router) {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }

    public navigateLandingPage(): void {
        this.router.navigate(['']);
    }

    public navigateArticle(article: BlogPost): void {
        this.curArticle = environment.preview ? null : article;
        // strip /blog from the target url
        this.router.navigate([new URL(article.url).pathname.substring(5)]);
        this.articleChangedSubject.next(article);
    }

    public navigateArticleByLanguage(id: string, lng: string): void {
        this.router.navigate([ROUTES.ARTICLE + id + '/' + lng]);
    }

    public navigateAuthor(author: Author): void {
        this.curAuthor = author;
        const url =
            ROUTES.AUTHOR + encodeURIComponent(author.firstname) + '/' + encodeURIComponent(author.surname);
        this.router.navigate([url]);
        this.authorChangedSubject.next(this.curAuthor);
    }

    public get articleChange(): Observable<BlogPost> {
        return this.articleChangedSubject.asObservable();
    }

    public get authorChange(): Observable<Author> {
        return this.authorChangedSubject.asObservable();
    }

    public get currentArticle(): BlogPost | null {
        return this.curArticle;
    }
}
